import { Tag } from '@ads/components-react';

import { getContractStatusTone } from '../../../types/contractStatus';

export interface ContractStatusBadgeProps {
  /** Texto de status do contrato, como veio do backend. */
  readonly status: string | null | undefined;
}

/**
 * Tag de status de um contrato financeiro.
 *
 * O tom é inferido do texto (ver `getContractStatusTone`), com fallback neutro
 * para status que o backend passe a devolver e ainda não estejam mapeados.
 * Nada é renderizado quando não há status.
 */
export function ContractStatusBadge({ status }: ContractStatusBadgeProps) {
  if (!status) return null;

  return (
    <Tag
      label={status}
      size="sm"
      status={getContractStatusTone(status)}
      custom={{ text: 'text-nowrap' }}
    />
  );
}
